<!-- eslint-disable vue/multi-word-component-names -->
<script>
  export default {
    data() {
      return {
        dashboardIMG: require('@/assets/images/dashboard.png'),
      };
    },
  };
</script>
<template>
  <v-card elevation="0" class="dashboard-card">
    <v-row no-gutters>
      <v-col cols="12">
        <v-img :src="dashboardIMG" contain class="dashboard-card-background-color"></v-img>
      </v-col>
    </v-row>
    <v-card-text class="dashboard-card-content">
      <slot></slot>
    </v-card-text>
  </v-card>
</template>
<style lang="scss" scoped>
  .dashboard-card {
    background: var(--background-color) !important;
    border-radius: 1rem !important;
    &-background-color {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      z-index: 0;
    }
    &-content {
      position: relative;
      z-index: 1;
    }
  }
</style>
